// extracted by mini-css-extract-plugin
export default {"form":"CreatePostForm_form__raM1+","input":"CreatePostForm_input__2vpI-","submitButton":"CreatePostForm_submitButton__Xig8e"};